import ErrorCodes from '../config/error';

class Exception {
    message;
    object;
    constructor(error){
        this.object = error;
        this.message = !!error && !!error.message ? error.message : undefined;
    }
}

export class APIException extends Exception {
    constructor(error){
        super(error);
        this.type = 'api';
        this.code = !!error.response && (!!error.response.status ? error.response.status : 500);
        this.data = !!error.response && (!!error.response.data ? error.response.data : 'unrecognized-error');
        this.status = !!error.response && (!!error.response.statusText ? error.response.statusText : 'Unrecognized server error!');
        this.message = !!ErrorCodes && (!!ErrorCodes[this.data] ? ErrorCodes[this.data].message : this.status);
        this.level = !!ErrorCodes && (!!ErrorCodes[this.data] ? ErrorCodes[this.data].level : 'fatal');

        console.log(this);
    }
}


export default Exception;